const firebaseConfig = {
  apiKey: "AIzaSyApiBxGHWhA6VRjcXcCfiArZ-Z7mCxyDsk",
  authDomain: "delevery-man.firebaseapp.com",
  projectId: "delevery-man",
  storageBucket: "delevery-man.appspot.com",
  messagingSenderId: "104501576221",
  appId: "1:104501576221:web:84833cd7400473947afcf4"
};

  export default firebaseConfig